import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import { injectQuery, queryOptions } from '@ngneat/query';
import { useQuery } from '@sona/angular-util-common';
import { ITarget } from '@sona/shared-model-common';
import { omitBy } from 'lodash';

import type { Paginated, PaginateQuery } from 'nestjs-paginate';

/**
 * Facade for handling actions and exposing state related to the scan detail page.
 */
@Injectable({ providedIn: 'root' })
export class SonaTargetBrowseFacade {
    private readonly _http = inject(HttpClient);
    private readonly _query = injectQuery();

    findAll(query$: Signal<Omit<PaginateQuery, 'path'>>) {
        return useQuery(query$, (query) =>
            queryOptions({
                queryKey: ['targets', query] as const,
                queryFn: () => {
                    const params = new URLSearchParams(
                        omitBy(query, (value) => value == null) as unknown as Record<string, string>
                    );
                    return this._http.get<Paginated<ITarget>>(
                        `/api/targets?${params}`
                    );
                },
                enabled: query?.limit !== 0
            })
        );
    }
}
